function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": {
          'report-list-button': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-button", {
          "attrs": {
            'icon': `open`,
            'size': `small`,
            'theme': `tertiary`,
          },
        }));
        __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
          "attrs": {
            placement: `top`
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat("Saved reports");;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'upsell-wrapper': true,
            'save-report': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-upsell-popup", {
            "attrs": {
              feature: `bookmark-maximum`,
              name: `saveReport`,
              open: $attr(`show-upsell`),
            },
            "on": {
              change: $helpers.closeUpsell
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;